import { Component, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import { RouterService } from 'src/app/services/router/router.service';
import { MaintenanceMenuService } from 'src/app/shared/maintenance-menu/maintenance-menu.service';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { MessageFieldComponent } from 'src/app/shared/message-field/message-field.component';
import { ToastrService } from 'ngx-toastr';
import { SolveUnmatchedStoresService } from './solve-unmatched-stores.service';
import { UploadResultModel } from 'src/app/shared/message-field/message-field.viewmodel';
import { AppAuthService } from 'src/app/services/auth/app-auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-solve-unmatched-stores',
  templateUrl: './solve-unmatched-stores.component.html',
  styleUrls: ['./solve-unmatched-stores.component.scss']
})
export class SolveUnmatchedStoresComponent implements OnInit {
  /* アンマッチ店舗ファイル */ 
  private unmatchedStoresFile: NgxFileDropEntry;
  /* 表示コンテンツ */ 
  public viewContent: string = 'view/download';
  /* 拡張子 */ 
  public allowedExtension = ".xlsx"
  /* メッセージフィールド */ 
  @ViewChild('messageField') private messageField: MessageFieldComponent;
  
  /**
   * コンストラクタ
   */
  constructor(
    public maintenanceMenuService: MaintenanceMenuService,
    private routerService: RouterService,
    private toastr: ToastrService,
    private solveUnmatchedStoresService: SolveUnmatchedStoresService,
    private appAuthService: AppAuthService) {}


  /**
   * 初期化処理
   */
  ngOnInit(): void {
    this.routerService.setPreviousPage();
  }

  /**
   * 店舗情報ファイル取得
   */
   public setUnmatchedStoresFile(file: NgxFileDropEntry) {
    // エクセルファイル未選択
    if(file !== null && !file.relativePath.endsWith(this.allowedExtension)){
      this.toastr.error("Excelファイル以外が選択されています。ファイルを再選択してください", "Excelファイル非選択");
      return;
    };
    this.unmatchedStoresFile = file;
  }

  /**
   * 店舗情報ファイルアップロード処理
   */
  public uploadUnmatchedStoresFile() {
    // ファイル未選択
    if(!this.unmatchedStoresFile || !this.unmatchedStoresFile.fileEntry.isFile){
      this.toastr.error('アンマッチ店舗ファイルが選択されていません。', 'アンマッチ店舗ファイル未選択');
      return;
    }

    const formData = new FormData();
    formData.append('organization', environment.organization);
    const fileEntry = this.unmatchedStoresFile.fileEntry as FileSystemFileEntry;
    fileEntry.file((file: File) => {
      formData.append('file', file, this.unmatchedStoresFile.relativePath);
      // 店舗情報ファイル取り込みAPI呼び出し
      this.solveUnmatchedStoresService.exportUnmatchedStores(formData).subscribe((res: UploadResultModel) => {
        this.messageField.pushMessage(res);
        // エラーあり
        if(res.errorCount > 0){
          this.toastr.error('アンマッチ店舗ファイルのアップロードに失敗しました', 'アップロード失敗');
        }
        // 警告あり
        else if(res.warningCount > 0){
          this.toastr.warning('アンマッチ店舗ファイルのアップロードで警告があります', 'アップロード警告');
        }
        // 正常終了
        else{
          this.toastr.info('アンマッチ店舗ファイルのアップロードが完了しました', 'アップロード完了');
        }
      })
    });
  }
}
